import { useMemo } from 'react'
import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from 'components/OfferList/OfferListTiles/Support/OfferTileLoggedInButtons'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import LEOfferForceBundlePricing from 'components/OfferList/OfferCards/LEOfferPricing/LEOfferForceBundlePricing'
import LEOfferPricing from 'components/OfferList/OfferCards/LEOfferPricing/LEOfferPricing'
import { unique } from 'lib/array/arrayUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'
import {
  PriceContentInner,
  PriceDetailsButton,
  PriceDetailsContainer,
  PriceDetailsContent,
  ViewOfferButton,
} from './LesaNlsOfferPriceDetails.shared'

interface Props {
  compact?: boolean
  offer: App.HotelOffer | App.HotelOfferSummary
  selectedDatesAndRoomsFilter?: App.OfferListFilters
}

export function LesaNlsLEOfferPriceDetails({ compact = false, offer, selectedDatesAndRoomsFilter }: Props) {
  const wall = (
    <OfferTileLoggedInButtons
      align="right"
      fullWidth={false}
      discountLabelAlign="end"
    />
  )
  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, offer))
  const shouldUseForceBundlePricing = !!(offer.bundledWithFlightsOnly || charterBundleRoute)
  const offerLocations = useMemo(
    () => unique(offer.locations.concat(offer.location)),
    [offer.locations, offer.location],
  )
  const vendorName = offer.vendorName

  return (
    <WalledContent enforced={offer.walledGarden} wall={wall}>
      <PriceDetailsContainer $compact={compact}>
        <PriceDetailsContent $compact={compact}>
          <PriceContentInner $compact={compact}>
            <VerticalSpacer gap={4}>
              <div>
                {shouldUseForceBundlePricing && (
                  <LEOfferForceBundlePricing
                    offer={offer}
                    selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter}
                  />
                )}
                {!shouldUseForceBundlePricing && (
                  <LEOfferPricing
                    offer={offer}
                    selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter}
                  />
                )}
              </div>
              <PriceRowAgentHubCommission
                offerId={offer.id}
                offerLocations={offerLocations}
                vendorName={vendorName}
                productType={offer.productType}
              />
            </VerticalSpacer>
          </PriceContentInner>
        </PriceDetailsContent>
        <PriceDetailsButton $compact={compact}>
          <ProductPaletteProvider product={offer}>
            <ViewOfferButton compact={compact} />
          </ProductPaletteProvider>
        </PriceDetailsButton>
      </PriceDetailsContainer>
    </WalledContent>
  )
}
